import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EftersynStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/eftersyn-state-enum';

@Component({
    selector: 'app-eftersyn-status',
    templateUrl: './eftersyn-status.component.html',
    styleUrls: ['./eftersyn-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EftersynStatusComponent implements OnInit {
  @Input() eftersynState: EftersynStateEnum;
  @Input() serviceordreNo: Number;

  eftersynStateEnum = EftersynStateEnum;

  constructor() {}

  ngOnInit(): void {}
}
